export const smartPosTerminalsCollectionGuard = 'GET /smart-pos-terminals';
export const smartPosTerminalResourceGuard = 'GET /smart-pos-terminals/d+';
export const createSmartPosTerminalsResourceGuard = 'POST /smart-pos-terminals';
export const editSmartPosTerminalResourceGuard = 'PUT /smart-pos-terminals/d+';
export const deleteSmartPosTerminalResourceGuard =
  'DELETE /smart-pos-terminals/d+';
